import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import EmptyOrderFinalPage from './empty-order-final-page';
import { styles } from './empty-order-final-page.styles';

export default compose(withStyles(styles))(EmptyOrderFinalPage);
